import { Helmet } from "react-helmet-async";
import Footer from "../components/Footer";
import Header from "../components/Header";
import "../Style.css";
const PrivacyPolicy = () => {
  return (
    <>
      <Helmet>
        <title>Privacy Policy | Own Your Money</title>
        <meta
          name="description"
          content="Privacy policy for Own Your Money's financial coaching services in the United States. Learn how we protect your personal information and maintain confidentiality."
        />
        <meta name="robots" content="noindex, follow" />
        <link
          rel="canonical"
          href="https://www.ownyourmoney.biz/privacypolicy"
        />
        <meta property="og:title" content="Privacy Policy | Own Your Money" />
        <meta
          property="og:description"
          content="Privacy policy for Own Your Money's financial coaching services locally in North Carolina and all over the United States. Learn how we protect your personal information and maintain confidentiality."
        />
        <meta
          property="og:url"
          content="https://www.ownyourmoney.biz/privacypolicy"
        />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="%PUBLIC_URL%/og-image.png" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta name="geo.region" content="US-NC" />
        <meta name="geo.country" content="United States" />
        <meta name="geo.placename" content="Holly Springs, NC" />
        <meta name="geo.position" content="35.65;-78.83" />
        <meta name="ICBM" content="35.65, -78.83" />
        <meta name="language" content="en-US" />
      </Helmet>
      <Header />
      <div className="legal-page">
        <h1>Own Your Money LLC Privacy Policy</h1>
        <div className="last-updated">Effective Date: 9/9/2025</div>
        <p>
          Own Your Money LLC respects your privacy and is committed to
          protecting your personal information. This Privacy Policy explains how
          we collect, use, disclose, and safeguard your information when you
          engage with our financial coaching services, visit our website, or
          otherwise interact with us.
        </p>
        <h2>1. Information We Collect</h2>
        <h3>a. Personal Information</h3>
        <p>We may collect the following personal information:</p>
        <ul>
          <li>Name</li>
          <li>
            Contact details (email address, phone number, mailing address)
          </li>
          <li>Date of birth</li>
          <li>Employment information</li>
        </ul>
        <h3>b. Financial Information (provided voluntarily during coaching)</h3>
        <ul>
          <li>Income, expenses, assets, and liabilities</li>
          <li>Budgeting details</li>
          <li>Credit reports or scores (if shared)</li>
          <li>Savings and investment goals</li>
        </ul>
        <h3>c. Technical Information (when using our website)</h3>
        <ul>
          <li>IP address</li>
          <li>Browser type and version</li>
          <li>Pages visited and time spent on the website</li>
          <li>Cookies and similar tracking technologies</li>
        </ul>
        <h2>2. How We Use Your Information</h2>
        <p>We use the information we collect to: </p>
        <ul>
          <li>Provide financial coaching and related services</li>
          <li>Develop personalized coaching plans</li>
          <li>
            Communicate with you about appointments, updates, or resources
          </li>
          <li>Improve our services and website performance</li>
          <li>Comply with legal and regulatory requirements</li>
        </ul>
        <h2>3. How We Share Your Information</h2>
        <p>
          We do not sell, rent, or trade your personal or financial information.
          We may share your information only in the following limited
          situations:
        </p>
        <ul>
          <li>
            <strong>Service Providers:</strong> With trusted vendors who perform
            services on our behalf (e.g., scheduling, payment processing, secure
            data storage)
          </li>
          <li>
            <strong>Legal Obligations:</strong> When required by law,
            regulation, or legal process
          </li>
          <li>
            <strong>Consent:</strong> With your explicit consent for specific
            purposes
          </li>
        </ul>
        <h2>4. Data Security</h2>
        <p>
          We implement reasonable technical, administrative, and physical
          safeguards to protect your personal and financial information from
          unauthorized access, disclosure, alteration, or destruction. However,
          no system can be guaranteed 100% secure.
        </p>
        <h2>5. Data Retention</h2>
        <p>
          We retain your information only for as long as necessary to provide
          our services, comply with legal obligations, resolve disputes, or
          enforce agreements.
        </p>
        <h2>6. Your Rights</h2>
        <p>Depending on your location, you may have the right to:</p>
        <ul>
          <li>Access, correct, or update your personal information</li>
          <li>Request deletion of your information</li>
          <li>Restrict or object to certain processing activities</li>
          <li>Withdraw consent (where applicable)</li>
        </ul>
        <p>
          To exercise these rights, please contact us at{" "}
          <a href="mailto:ownyourmoneync@gmail.com">ownyourmoneync@gmail.com</a>
        </p>
        <h2>7. Children’s Privacy</h2>
        <p>
          Our services are not directed toward individuals under the age of 18.
          We do not knowingly collect information from children.
        </p>
        <h2>8. Third-Party Links</h2>
        <p>
          Our website may contain links to third-party websites. We are not
          responsible for the privacy practices of these external sites and
          encourage you to review their policies.
        </p>
        <h2>9. Updates to This Policy</h2>
        <p>
          We may update this Privacy Policy from time to time. The updated
          version will be indicated by the 'Effective Date' and will be
          effective once posted.
        </p>
        <h2>10. Contact Us</h2>
        <p>
          If you have questions about this Privacy Policy or our practices,
          please contact us:
        </p>
        <div
          style={{ marginTop: "1.5rem", fontSize: "1.1rem", textAlign: "left" }}
        >
          <div>
            <strong>OwnYourMoney LLC</strong>
          </div>
          <div>
            Email:{" "}
            <a
              href="mailto:ownyourmoneync@gmail.com"
              style={{
                color: "#2e3092",
                textDecoration: "none",
                fontWeight: "bold",
              }}
            >
              ownyourmoneync@gmail.com
            </a>
          </div>
          <div>Phone: 919-285-1689</div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default PrivacyPolicy;
